(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-rich-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ATOMIC = 'a, code, sup, sub, button';
  var WORD_LIMIT = 300;

  function splitWords(content) {
    var walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.textContent.trim()) return NodeFilter.FILTER_REJECT;
        if (node.parentElement && node.parentElement.closest(ATOMIC)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(function (node) {
      var frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (!part.trim()) { frag.appendChild(document.createTextNode(part)); return; }
        var span = document.createElement('span');
        span.className = 'mtx-art__w';
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
    /* Links and other atomic inline elements animate as one unit so their
       markup, focus behavior, and underlines are never split apart. */
    content.querySelectorAll(ATOMIC).forEach(function (el) {
      if (!el.textContent.trim()) return;
      if (el.parentElement && el.parentElement.closest(ATOMIC)) return;
      el.classList.add('mtx-art__w');
    });
    return content.querySelectorAll('.mtx-art__w');
  }

  function markElements(content) {
    var kids = content.children.length ? content.children : [content];
    Array.prototype.forEach.call(kids, function (el) {
      el.classList.add('mtx-art__w');
    });
    return content.querySelectorAll('.mtx-art__w');
  }

  function setup(root) {
    root.setAttribute('data-mtx-art-ready', '1');
    if (root.dataset.animate !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var content = root.querySelector('.mtx-art__content');
    if (!content) return;

    var mode = root.dataset.mode === 'element' ? 'element' : 'word';
    if (mode === 'word') {
      var wordCount = (content.textContent.match(/\S+/g) || []).length;
      if (wordCount > WORD_LIMIT) mode = 'element';
    }
    var units = mode === 'word' ? splitWords(content) : markElements(content);
    if (!units.length) return;

    for (var i = 0; i < units.length; i++) {
      units[i].style.setProperty('--mtx-art-i', i);
    }
    root.classList.add('mtx-art--split');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('mtx-art--in');
          io.disconnect();
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);
  }

  function initAll() {
    var roots = document.querySelectorAll('.mtx-art:not([data-mtx-art-ready])');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-downloads"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) {
        el.classList.add('apex-in');
        return;
      }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var nav = document.querySelector('[data-apex-nav]');
  if (!nav) return;
  var sync = function () { nav.classList.toggle('apex-nav--stuck', window.scrollY > 8); };
  sync();
  window.addEventListener('scroll', sync, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-machine-rules"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-apex-buy]').forEach(function (root) {
    var variantInput = root.querySelector('[data-apex-variant-input]');
    var planInput = root.querySelector('[data-apex-plan-input]');
    var submit = root.querySelector('[data-apex-submit]');
    if (!variantInput || !planInput || !submit) return;

    var apply = function (variantId, planName) {
      variantInput.value = variantId;
      root.querySelectorAll('[data-apex-plans]').forEach(function (group) {
        var active = group.getAttribute('data-apex-plans') === variantId;
        group.hidden = !active;
        group.disabled = !active;
      });

      var group = root.querySelector('[data-apex-plans="' + variantId + '"]');
      var chosen = null;
      if (group) {
        var radios = group.querySelectorAll('input[data-apex-plan]');
        if (planName) {
          radios.forEach(function (radio) {
            if (!chosen && radio.getAttribute('data-plan-name') === planName) chosen = radio;
          });
        }
        if (!chosen) chosen = radios[0];
        if (chosen) chosen.checked = true;
      }
      planInput.value = chosen ? chosen.value : '';

      var key = variantId + ':' + planInput.value;
      root.querySelectorAll('[data-apex-price-node]').forEach(function (node) {
        node.hidden = node.getAttribute('data-apex-price-node') !== key;
      });

      var seat = root.querySelector('input[data-apex-variant][value="' + variantId + '"]');
      var available = seat ? seat.getAttribute('data-available') === 'true' : true;
      submit.disabled = !available;
      submit.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
      root.classList.toggle('is-oos', !available);
      var oosRoot = root.querySelector('[data-oos-lead]');
      if (oosRoot) {
        oosRoot.classList.toggle('is-oos', !available);
        var oosTrigger = oosRoot.querySelector('[data-oos-lead-open]');
        if (oosTrigger) {
          oosTrigger.hidden = available;
          oosTrigger.classList.toggle('is-hidden', available);
        }
      }
      if (seat && window.history.replaceState) {
        window.history.replaceState({}, '', seat.getAttribute('data-variant-url'));
      }
    };

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target.matches('input[data-apex-variant]')) {
        var open = root.querySelector('[data-apex-plans]:not([hidden]) input[data-apex-plan]:checked');
        apply(target.value, open ? open.getAttribute('data-plan-name') : null);
      } else if (target.matches('input[data-apex-plan]')) {
        apply(variantInput.value, target.getAttribute('data-plan-name'));
      }
    });

    var form = submit.closest('form');
    var adding = false;
    var addingTimer = 0;

    var stopAdding = function (payload) {
      if (!adding) return;
      if (payload && payload.action) {
        var actions = window.themeCore && window.themeCore.CartApi && window.themeCore.CartApi.actions;
        var addOne = actions ? actions.ADD_TO_CART : 'addItem';
        var addMany = actions ? actions.ADD_TO_CART_MANY : 'addItems';
        if (payload.action !== addOne && payload.action !== addMany) return;
      }
      adding = false;
      if (addingTimer) {
        clearTimeout(addingTimer);
        addingTimer = 0;
      }
      var seat = root.querySelector('input[data-apex-variant][value="' + variantInput.value + '"]');
      var available = seat ? seat.getAttribute('data-available') === 'true' : true;
      submit.disabled = !available;
      submit.textContent = available ? root.dataset.addLabel : root.dataset.soldOutLabel;
    };

    if (form) {
      form.addEventListener('submit', function () {
        if (submit.disabled) return;
        adding = true;
        submit.disabled = true;
        submit.textContent = root.dataset.addingLabel;
        addingTimer = setTimeout(stopAdding, 8000);
      });
    }

    var bindCartEvents = function () {
      var bus = window.themeCore && window.themeCore.EventBus;
      if (!bus || typeof bus.listen !== 'function') return false;
      bus.listen(['cart:updated', 'cart:drawer:open', 'cart:refresh', 'cart-notification:open'], stopAdding);
      return true;
    };
    if (!bindCartEvents()) {
      document.addEventListener('theme:all:loaded', bindCartEvents, { once: true });
    }
    document.addEventListener('cart:updated', function (event) {
      stopAdding(event && event.detail);
    });
    document.addEventListener('cart:refresh', stopAdding);
  });

  document.querySelectorAll('[data-apex-gallery]').forEach(function (stage) {
    var wrap = stage.parentElement;
    wrap.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-apex-thumb]');
      if (!thumb) return;
      var id = thumb.getAttribute('data-apex-thumb');
      stage.querySelectorAll('[data-apex-media]').forEach(function (img) {
        img.hidden = img.getAttribute('data-apex-media') !== id;
      });
      wrap.querySelectorAll('[data-apex-thumb]').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button === thumb));
      });
    });
  });

  var film = document.querySelector('[data-apex-film]');
  if (!film || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var gate = film.querySelector('.apex-film__gate');
  var strip = film.querySelector('.apex-film__strip');
  var stacks = film.querySelectorAll('.apex-film__stack');
  var units = parseFloat(film.getAttribute('data-apex-units')) || 0;
  var cuts = (film.getAttribute('data-apex-cuts') || '')
    .split(',')
    .filter(Boolean)
    .map(Number);

  // Measure against the grid, not the frame. The frame is sticky on desktop, so
  // its own top stops changing once it pins and the film would stall mid-feed.
  var track = film.closest('.apex-buy__inner') || gate;
  var queued = false;
  var stacked = -1;

  var settle = function (done) {
    if (done === stacked) return;
    stacked = done;
    stacks.forEach(function (stack) {
      var pieces = stack.children;
      for (var i = 0; i < pieces.length; i++) {
        pieces[i].classList.toggle('is-out', i < done);
      }
    });
  };

  var feed = function () {
    queued = false;
    var gateHeight = gate.clientHeight;
    var travel = strip.offsetHeight - gateHeight;
    if (travel <= 0 || !units) return;

    var box = track.getBoundingClientRect();
    var progress = (window.innerHeight - box.top) / (window.innerHeight + box.height);
    progress = Math.min(1, Math.max(0, progress));

    // The film feeds down into the tray. At rest the strip sits fully raised so
    // its last row is at the cutting edge, and it lowers to zero as you scroll.
    film.style.setProperty('--apex-feed', ((progress - 1) * travel).toFixed(1));

    // Strip-local point sitting at the cutting edge, in viewBox units. A row is
    // cut once its mark has travelled below that edge.
    var perPixel = units / strip.offsetHeight;
    var atEdge = units - progress * (units - gateHeight * perPixel);
    var done = 0;
    for (var i = 0; i < cuts.length; i++) {
      if (cuts[i] > atEdge) done++;
    }
    settle(done);
  };

  var request = function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(feed);
  };

  feed();
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  window.addEventListener('load', request);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-page-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexPageNav) return;
  window.__apexPageNav = true;

  var observers = [];

  function disconnectAll() {
    observers.forEach(function (io) {
      io.disconnect();
    });
    observers = [];
  }

  function bindNav(nav) {
    var links = nav.querySelectorAll('.apex-pagenav__link');
    if (!links.length) return;

    var items = [];
    links.forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var hash = href.indexOf('#');
      if (hash === -1) return;
      var id = href.slice(hash + 1);
      if (!id) return;
      var target = document.getElementById(id);
      if (target) items.push({ id: id, link: link, target: target });
    });
    if (!items.length) return;

    var visible = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      var activeId = '';
      items.forEach(function (item) {
        if (!activeId && visible[item.id]) activeId = item.id;
      });
      if (!activeId) return;
      links.forEach(function (link) {
        var href = link.getAttribute('href') || '';
        var hash = href.indexOf('#');
        var id = hash === -1 ? '' : href.slice(hash + 1);
        var on = id === activeId;
        link.classList.toggle('is-on', on);
        if (on) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    items.forEach(function (item) {
      io.observe(item.target);
    });
    observers.push(io);
  }

  function scan() {
    disconnectAll();
    document.querySelectorAll('[data-apex-pagenav]').forEach(bindNav);
  }

  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-pricing-summary"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

document.querySelectorAll('[data-apex-pick-cadence]').forEach(function (link) {
  link.addEventListener('click', function (event) {
    var cadence = link.getAttribute('data-apex-pick-cadence');
    var input = document.querySelector('[data-apex-plan][data-cadence="' + cadence + '"]');
    if (!input) return;
    event.preventDefault();
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    var main = document.getElementById('main');
    if (main) main.scrollIntoView({ block: 'start' });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-spec-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.__apexReveal) {
    window.__apexReveal = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('apex-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var scan = function () {
      document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add('apex-in');
          return;
        }
        el.classList.add('apex-reveal');
        io.observe(el);
      });
    };
    scan();
    document.addEventListener('shopify:section:load', scan);
  }

  var bindSpecs = function () {
    var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    document.querySelectorAll('[data-apex-spec]').forEach(function (cell) {
      if (cell.dataset.apexSpecBound) return;
      cell.dataset.apexSpecBound = 'true';
      if (fineHover) return;
      cell.addEventListener('click', function () {
        document.querySelectorAll('[data-apex-spec].is-on').forEach(function (other) {
          if (other !== cell) other.classList.remove('is-on');
        });
        cell.classList.toggle('is-on');
      });
    });
  };
  bindSpecs();
  document.addEventListener('shopify:section:load', bindSpecs);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-stat-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.__apexReveal) {
    window.__apexReveal = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('apex-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var scan = function () {
      document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
        el.classList.add('apex-reveal');
        io.observe(el);
      });
    };
    scan();
    document.addEventListener('shopify:section:load', scan);
  }

  var DURATION = 1100;
  var NUMBER = /\d[\d,]*(?:\.\d+)?/g;

  // Match the target's own decimal places and thousands grouping, so a value
  // the merchant typed as 1,200 counts through 1,043 and not 1043.
  var format = function (target, value) {
    var decimals = target.indexOf('.') > -1 ? target.split('.')[1].length : 0;
    var out = value.toFixed(decimals);
    if (target.indexOf(',') > -1) {
      var parts = out.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      out = parts.join('.');
    }
    return out;
  };

  // Rebuild the value as text nodes plus one span per number. Built with the
  // DOM rather than innerHTML, so merchant text is never parsed as markup.
  var split = function (el) {
    var text = el.textContent;
    var frag = document.createDocumentFragment();
    var spans = [];
    var last = 0;
    var match;
    NUMBER.lastIndex = 0;
    while ((match = NUMBER.exec(text)) !== null) {
      if (match.index > last) frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      var span = document.createElement('span');
      span.setAttribute('data-apex-to', match[0]);
      span.textContent = format(match[0], 0);
      frag.appendChild(span);
      spans.push(span);
      last = match.index + match[0].length;
    }
    if (!spans.length) return null;
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    el.textContent = '';
    el.appendChild(frag);
    return spans;
  };

  var count = function (spans) {
    var began = null;
    var frame = function (now) {
      if (began === null) began = now;
      var t = Math.min(1, (now - began) / DURATION);
      var eased = 1 - Math.pow(1 - t, 3);
      spans.forEach(function (span) {
        var target = span.getAttribute('data-apex-to');
        span.textContent = format(target, parseFloat(target.replace(/,/g, '')) * eased);
      });
      if (t < 1) {
        window.requestAnimationFrame(frame);
      } else {
        spans.forEach(function (span) { span.textContent = span.getAttribute('data-apex-to'); });
      }
    };
    window.requestAnimationFrame(frame);
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var counter = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      counter.unobserve(entry.target);
      var spans = entry.target.__apexSpans;
      if (spans) count(spans);
    });
  }, { rootMargin: '0px 0px -12% 0px' });

  var scanCounts = function () {
    document.querySelectorAll('[data-apex-count]:not([data-apex-counted])').forEach(function (el) {
      el.setAttribute('data-apex-counted', '');
      var spans = split(el);
      if (!spans) return;
      el.__apexSpans = spans;
      counter.observe(el);
    });
  };
  scanCounts();
  document.addEventListener('shopify:section:load', scanCounts);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-use-cases"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__apexReveal) return;
  window.__apexReveal = true;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('apex-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  var scan = function () {
    document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
      el.classList.add('apex-reveal');
      io.observe(el);
    });
  };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-workflow"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.__apexReveal) {
    window.__apexReveal = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('apex-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var scan = function () {
      document.querySelectorAll('[data-apex-reveal]:not(.apex-in):not(.apex-reveal)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) { el.classList.add('apex-in'); return; }
        el.classList.add('apex-reveal');
        io.observe(el);
      });
    };
    scan();
    document.addEventListener('shopify:section:load', scan);
  }

  if (window.__apexCopy) return;
  window.__apexCopy = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-apex-copy]');
    if (!button || !navigator.clipboard) return;
    var source = document.getElementById(button.getAttribute('data-apex-copy'));
    if (!source) return;
    var idle = button.textContent;
    navigator.clipboard.writeText(source.textContent.trim()).then(function () {
      button.textContent = button.getAttribute('data-copied-label');
      window.setTimeout(function () { button.textContent = idle; }, 2000);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["automation-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function hydrateHeroVideo(hero) {
    if (!hero || hero.getAttribute('data-mtx-video-ready') === '1') return;
    var video = hero.querySelector('video.mtx-hero__video');
    if (!video) return;
    hero.setAttribute('data-mtx-video-ready', '1');
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    var play = function () {
      var p = video.play();
      if (p && typeof p.then === 'function') {
        p.then(function () {
          video.classList.remove('mtx-hero__video--pending');
          hero.classList.add('is-video-ready');
        }).catch(function () { /* autoplay blocked — keep poster */ });
      } else {
        video.classList.remove('mtx-hero__video--pending');
        hero.classList.add('is-video-ready');
      }
    };
    if (video.readyState >= 2) {
      play();
    } else {
      video.addEventListener('loadeddata', play, { once: true });
      /* Kick network only after we decide to hydrate */
      try { video.load(); } catch (e) {}
    }
  }

  function connectionBlocked() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    var type = String(c.effectiveType || '');
    return type === 'slow-2g' || type === '2g';
  }

  function scheduleHeroVideos() {
    var heroes = document.querySelectorAll('.mtx-hero');
    if (!heroes.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || connectionBlocked()) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;

    function start() {
      heroes.forEach(function (hero) { hydrateHeroVideo(hero); });
    }

    function afterLoad() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(start, { timeout: 8000 });
      } else {
        setTimeout(start, 4000);
      }
    }

    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHeroVideos);
  } else {
    scheduleHeroVideos();
  }
  document.addEventListener('shopify:section:load', scheduleHeroVideos);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mtx-watch-cycle]');
    if (!btn) return;
    var hero = btn.closest('.mtx-hero');
    var video = hero && hero.querySelector('video');
    if (!video) return;
    hydrateHeroVideo(hero);
    video.currentTime = 0;
    video.setAttribute('controls', 'controls');
    video.play();
  });

  /**
   * ShopQuotes custom mode always quotes the *entire cart*.
   * Homepage "Request a Quote" must only show the configured Apex handles —
   * not whatever else is already in the shopper's cart (e.g. Vector, warranty).
   *
   * Flow:
   *  1) Snapshot + clear cart
   *  2) Add only quote_product_handles
   *  3) Click the permanent .request-quote-btn proxy ShopQuotes bound on boot
   *  4) Restore the shopper's original cart
   */
  function parseHandles(value) {
    return (value || '')
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);
  }

  function delay(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('product ' + handle + ' ' + res.status);
      return res.json();
    });
  }

  function pickVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    var available = product.variants.find(function (v) { return v.available; });
    return available || product.variants[0];
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('cart.js ' + res.status);
      return res.json();
    });
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/clear ' + res.status);
      return res.json().catch(function () { return null; });
    });
  }

  function addItemsToCart(items) {
    if (!items || !items.length) return Promise.resolve(null);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok && res.status !== 422) throw new Error('cart/add ' + res.status);
      return res.json().catch(function () { return null; });
    });
  }

  function snapshotCart(cart) {
    return (cart.items || []).map(function (item) {
      var entry = {
        id: item.variant_id,
        quantity: item.quantity
      };
      if (item.properties && Object.keys(item.properties).length) {
        entry.properties = item.properties;
      }
      return entry;
    });
  }

  function notifyCartUpdated(cart) {
    var payload = cart || { item_count: 0 };
    try {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: payload }));
    } catch (err) { /* ignore */ }
    if (window.themeCore && window.themeCore.EventBus && typeof window.themeCore.EventBus.emit === 'function') {
      try {
        window.themeCore.EventBus.emit('cart:updated', payload);
      } catch (err) { /* ignore */ }
    }
  }

  function buildQuoteItems(handles) {
    return Promise.all(handles.map(function (handle) {
      return fetchProduct(handle)
        .then(function (product) {
          var variant = pickVariant(product);
          if (!variant) return null;
          return { id: variant.id, quantity: 1 };
        })
        .catch(function (err) {
          console.warn('[mtx-quote] could not load product', handle, err);
          return null;
        });
    })).then(function (items) {
      return items.filter(Boolean);
    });
  }

  /**
   * Swap cart to quote-only items, run openFn, then restore the original cart.
   * ShopQuotes copies cart → quote list during open; restore is safe after that.
   */
  function withQuoteOnlyCart(handles, openFn) {
    var originalItems = [];

    return getCart()
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        originalItems = snapshotCart(cart);
        return clearCart();
      })
      .then(function () {
        return buildQuoteItems(handles);
      })
      .then(function (quoteItems) {
        if (!quoteItems.length) {
          throw new Error('no quote products resolved');
        }
        return addItemsToCart(quoteItems);
      })
      .then(function () {
        openFn();
        /* Give ShopQuotes time to read cart.js and copy lines into the quote */
        return delay(900);
      })
      .then(function () {
        return clearCart();
      })
      .then(function () {
        return addItemsToCart(originalItems);
      })
      .then(function () {
        return getCart().catch(function () { return { item_count: originalItems.length }; });
      })
      .then(function (cart) {
        notifyCartUpdated(cart);
      })
      .catch(function (err) {
        /* Best-effort restore if anything failed mid-flight */
        console.warn('[mtx-quote] quote cart swap failed', err);
        return clearCart()
          .catch(function () { return null; })
          .then(function () { return addItemsToCart(originalItems); })
          .then(function () {
            return getCart().catch(function () { return null; });
          })
          .then(function (cart) {
            if (cart) notifyCartUpdated(cart);
            throw err;
          });
      });
  }

  function findShopQuotesProxy(selector) {
    var proxy = document.querySelector('[data-mtx-sq-proxy].request-quote-btn');
    if (proxy) return proxy;
    try {
      if (selector) return document.querySelector(selector);
    } catch (err) { /* invalid selector */ }
    return document.querySelector('.request-quote-btn');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mtx-quote-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    if (trigger.getAttribute('data-mtx-quote-busy') === '1') return;
    trigger.setAttribute('data-mtx-quote-busy', '1');
    trigger.setAttribute('aria-busy', 'true');

    var selector = trigger.getAttribute('data-mtx-quote-selector') || '.request-quote-btn';
    var handles = parseHandles(trigger.getAttribute('data-mtx-quote-products'));
    var fallbackHref = trigger.getAttribute('href') || '/pages/contact';
    var proxy = findShopQuotesProxy(selector);

    function openProxy() {
      if (!proxy) throw new Error('ShopQuotes proxy not found');
      var prevPE = proxy.style.pointerEvents;
      proxy.style.pointerEvents = 'auto';
      proxy.click();
      proxy.style.pointerEvents = prevPE || 'none';
    }

    var run = handles.length
      ? withQuoteOnlyCart(handles, openProxy)
      : Promise.resolve().then(openProxy);

    run
      .catch(function (err) {
        console.warn('[mtx-quote] open failed, falling back', err);
        window.location.href = fallbackHref;
      })
      .then(function () {
        trigger.removeAttribute('data-mtx-quote-busy');
        trigger.removeAttribute('aria-busy');
      });
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["automation-roi-block"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-mtx-roi-teaser]:not([data-mtx-ready])').forEach(function (teaser) {
      teaser.setAttribute('data-mtx-ready', '1');
      var slider = teaser.querySelector('[data-mtx-roi-volume]');
      var manualRate = parseInt(teaser.dataset.manualRate, 10) || 120;
      var x6Rate = parseInt(teaser.dataset.x6Rate, 10) || 420;
      function update() {
        var v = parseInt(slider.value, 10);
        teaser.querySelector('[data-mtx-roi-volume-label]').textContent = v.toLocaleString();
        teaser.querySelector('[data-mtx-roi-manual]').textContent = (v / manualRate).toFixed(1);
        teaser.querySelector('[data-mtx-roi-x6]').textContent = (v / x6Rate).toFixed(1);
      }
      slider.addEventListener('input', update);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-closing"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-mtx-email-capture]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[type="email"]');
    if (!input.checkValidity()) { input.reportValidity(); return; }
    form.hidden = true;
    var success = form.parentElement.querySelector('.mtx-faq__email-success');
    if (success) success.hidden = false;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["labor-day-sale"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? "0" + n : String(n);
    }

    function wallTimeToMs(dateStr, timeStr, tz) {
      var hm = (timeStr || "23:59").split(":");
      var hh = parseInt(hm[0], 10);
      var mm = parseInt(hm[1], 10) || 0;
      if (isNaN(hh) || isNaN(mm)) return NaN;
      var parts = (dateStr || "").split("-");
      if (parts.length !== 3) return Date.parse(dateStr);
      var y = parseInt(parts[0], 10);
      var mo = parseInt(parts[1], 10);
      var d = parseInt(parts[2], 10);
      var utcGuess = Date.UTC(y, mo - 1, d, hh, mm, 0);
      var dtf = new Intl.DateTimeFormat("en-US", {
        timeZone: tz || "America/Los_Angeles",
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
      var map = {};
      dtf.formatToParts(new Date(utcGuess)).forEach(function (p) {
        map[p.type] = p.value;
      });
      var hour = parseInt(map.hour, 10);
      if (hour === 24) hour = 0;
      var asUtc = Date.UTC(+map.year, +map.month - 1, +map.day, hour, +map.minute, +map.second);
      return utcGuess - (asUtc - utcGuess);
    }

    function tick(el) {
      var end = wallTimeToMs(
        el.getAttribute("data-end-date"),
        el.getAttribute("data-end-time"),
        el.getAttribute("data-end-tz")
      );
      if (!end) return;
      var diff = Math.max(0, end - Date.now());
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      s -= m * 60;
      var set = function (sel, val) {
        var node = el.querySelector(sel);
        if (node) node.textContent = pad(val);
      };
      set("[data-ld-d]", d);
      set("[data-ld-h]", h);
      set("[data-ld-m]", m);
      set("[data-ld-s]", s);
    }

    function init() {
      document.querySelectorAll("[data-ld-countdown]").forEach(function (el) {
        tick(el);
        window.setInterval(function () { tick(el); }, 1000);
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  var wraps = [];
  var ticking = false;

  function collect() {
    wraps = Array.prototype.slice.call(document.querySelectorAll('.mtx-benefits [data-mtx-glow]'));
  }

  function update() {
    ticking = false;
    var vh = window.innerHeight || 1;
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var host = wrap.closest('.mtx-benefits') || wrap;
      var rect = host.getBoundingClientRect();
      /* -1 when section is below fold → +1 when above */
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      progress = Math.max(-1.2, Math.min(1.2, progress));
      var gx = 42 + progress * -28;
      var gy = 36 + progress * 22;
      var scale = 1 + Math.abs(progress) * 0.12;
      wrap.style.setProperty('--mtx-gx', gx.toFixed(1) + '%');
      wrap.style.setProperty('--mtx-gy', gy.toFixed(1) + '%');
      wrap.style.setProperty('--mtx-gscale', scale.toFixed(3));
    }
  }

  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function boot() {
    collect();
    if (!wraps.length) return;
    request();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-deep-dive"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs() {
    document.querySelectorAll('[data-mtx-tabs]:not([data-mtx-ready])').forEach(function (root) {
      root.setAttribute('data-mtx-ready', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t, idx) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', String(active));
          var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
          var img = root.querySelector('[data-mtx-tab-image="' + (idx + 1) + '"]');
          if (img) img.hidden = !active;
        });
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (next === null) return;
          e.preventDefault();
          var t = tabs[(next + tabs.length) % tabs.length];
          t.focus();
          select(t);
        });
      });
    });
  }
  function bindHotspots(root) {
    var tag = root.querySelector('[data-mtx-hs-data]');
    var DATA = {};
    try { DATA = JSON.parse(tag.textContent); } catch (e) { return; }
    function closeAll() {
      root.querySelectorAll('[data-hs]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      var p = root.querySelector('.mtx-hs__panel'); if (p) p.hidden = true;
    }
    function open(id) {
      var d = DATA[id]; if (!d) return;
      root.querySelectorAll('[data-hs]').forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-hs') === id ? 'true' : 'false'); });
      var p = root.querySelector('.mtx-hs__panel');
      p.querySelector('.mtx-hs__title').textContent = d.t;
      p.querySelector('.mtx-hs__body').textContent = d.b;
      p.hidden = false;
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hs]'); if (!btn) return;
      if (btn.getAttribute('aria-expanded') === 'true') closeAll(); else open(btn.getAttribute('data-hs'));
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }
  function initHotspots() {
    document.querySelectorAll('[data-mtx-hotspots]:not([data-hs-ready])').forEach(function (r) { r.setAttribute('data-hs-ready', '1'); bindHotspots(r); });
  }
  initTabs();
  initHotspots();
  document.addEventListener('shopify:section:load', initTabs);
  document.addEventListener('shopify:section:load', initHotspots);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVideo() {
    document.querySelectorAll('[data-mtx-yt]:not([data-mtx-ready])').forEach(function (host) {
      host.setAttribute('data-mtx-ready', '1');
      host.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mtx-yt-play]')) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + host.dataset.mtxYt + '?autoplay=1&rel=0';
        iframe.title = host.dataset.mtxYtTitle || 'Customer story video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        host.replaceChildren(iframe);
        iframe.focus();
      });
    });
  }

  function initQuotes() {
    document.querySelectorAll('[data-mtx-quotes]:not([data-mtx-ready])').forEach(function (root) {
      root.setAttribute('data-mtx-ready', '1');
      var quotes = Array.prototype.slice.call(root.querySelectorAll('[data-mtx-quote]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mtx-dot]'));
      var pauseBtn = root.querySelector('[data-mtx-pause]');
      if (quotes.length < 2) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var interval = (parseInt(root.dataset.mtxInterval, 10) || 6) * 1000;
      var auto = root.hasAttribute('data-mtx-autorotate') && !reduceMotion;
      var current = 0;
      var timer = null;
      var userPaused = false;
      var hasEnteredView = false;

      function show(i) {
        current = (i + quotes.length) % quotes.length;
        quotes.forEach(function (q, idx) {
          q.classList.toggle('is-active', idx === current);
          if (idx === current) { q.removeAttribute('aria-hidden'); } else { q.setAttribute('aria-hidden', 'true'); }
        });
        dots.forEach(function (d, idx) {
          d.classList.toggle('is-active', idx === current);
          if (idx === current) { d.setAttribute('aria-current', 'true'); } else { d.removeAttribute('aria-current'); }
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() {
        if (!auto || userPaused || timer || document.hidden || !hasEnteredView) return;
        timer = setInterval(function () { show(current + 1); }, interval);
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.dataset.mtxDot, 10) || 0);
          stop(); start();
        });
      });
      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-pressed', String(userPaused));
          pauseBtn.setAttribute('aria-label', userPaused ? 'Resume quote rotation' : 'Pause quote rotation');
          if (userPaused) { stop(); } else { start(); }
        });
      }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });

      if (!auto) return;
      if ('IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) {
            if (!e.isIntersecting || hasEnteredView) return;
            hasEnteredView = true;
            show(0);
            start();
            obs.disconnect();
          });
        }, { threshold: 0.15 });
        vio.observe(root);
      } else {
        hasEnteredView = true;
        start();
      }
    });
  }

  function boot() { initVideo(); initQuotes(); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  var EVENT = 'support:machine';
  var PARAM = 'machine';
  var MAX_OPTIONS = 50;

  // Product numbers get written many ways: "T1620-AS", "t1620 as", "T1620AS".
  // Matching on a punctuation-free copy makes all three forms find the machine.
  function compact(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function readMachineParam() {
    return new URLSearchParams(location.search).get(PARAM) || '';
  }

  function writeMachineParam(handle) {
    var params = new URLSearchParams(location.search);
    if (handle) params.set(PARAM, handle);
    else params.delete(PARAM);
    var search = params.toString();
    history.replaceState(history.state, '', location.pathname + (search ? '?' + search : '') + location.hash);
  }

  function init(root) {
    if (root.hasAttribute('data-sh-ready')) return;

    var dataEl = root.querySelector('[data-sh-machines]');
    var input = root.querySelector('[data-sh-input]');
    var list = root.querySelector('[data-sh-list]');
    if (!dataEl || !input || !list) return;

    var machines;
    try {
      machines = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    root.setAttribute('data-sh-ready', '');

    var picker = root.querySelector('[data-sh-picker]');
    var panel = root.querySelector('[data-sh-machine]');
    var noMatch = root.querySelector('[data-sh-nomatch]');
    var noMatchQ = root.querySelector('[data-sh-nomatch-q]');
    var status = root.querySelector('[data-sh-status]');
    var img = root.querySelector('[data-sh-machine-img]');
    var seriesEl = root.querySelector('[data-sh-machine-series]');
    var titleEl = root.querySelector('[data-sh-machine-title]');
    var skuRow = root.querySelector('[data-sh-machine-sku-row]');
    var skuEl = root.querySelector('[data-sh-machine-sku]');
    var manualBtn = root.querySelector('[data-sh-manual]');
    var noManual = root.querySelector('[data-sh-no-manual]');
    var videosBtn = root.querySelector('[data-sh-videos]');
    var videosN = root.querySelector('[data-sh-videos-n]');
    var partsBtn = root.querySelector('[data-sh-parts]');
    var productBtn = root.querySelector('[data-sh-product]');
    var changeBtn = root.querySelector('[data-sh-change]');
    var partsUrl = root.getAttribute('data-parts-url') || '';

    var matches = [];
    var active = -1;
    var current = null;

    machines.forEach(function (m) {
      m.words = [m.title, m.sku, m.series].join(' ').toLowerCase();
      m.compact = compact(m.words);
      m.compactSku = compact(m.sku);
    });

    function find(handle) {
      if (!handle) return null;
      return machines.filter(function (m) { return m.handle === handle; })[0] || null;
    }

    function search(query) {
      var q = query.toLowerCase().trim();
      if (!q) return machines.slice();
      var tokens = q.split(/\s+/);
      var cq = compact(q);
      var rank = function (m) {
        return cq && m.compactSku.indexOf(cq) === 0 ? 0 : 1;
      };
      // A product number copied from the machine label puts that machine first.
      return machines.filter(function (m) {
        return tokens.every(function (token) {
          if (m.words.indexOf(token) !== -1) return true;
          var ct = compact(token);
          return ct !== '' && m.compact.indexOf(ct) !== -1;
        });
      }).sort(function (a, b) { return rank(a) - rank(b); });
    }

    function setActive(index) {
      var previous = list.querySelector('[aria-selected="true"]');
      if (previous) previous.setAttribute('aria-selected', 'false');
      active = index;
      var option = index < 0 ? null : document.getElementById(list.id + '-' + index);
      if (!option) {
        active = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    function setOpen(open) {
      list.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) setActive(-1);
    }

    function renderOptions() {
      var query = input.value.trim();
      matches = search(query).slice(0, MAX_OPTIONS);
      list.textContent = '';

      matches.forEach(function (m, i) {
        var option = document.createElement('li');
        option.id = list.id + '-' + i;
        option.className = 'support-hub__option';
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.setAttribute('data-index', String(i));

        if (m.image) {
          var thumb = document.createElement('img');
          thumb.className = 'support-hub__option-img';
          thumb.src = m.image;
          thumb.alt = '';
          thumb.width = 40;
          thumb.height = 40;
          thumb.loading = 'lazy';
          option.appendChild(thumb);
        }

        var text = document.createElement('span');
        text.className = 'support-hub__option-text';
        var title = document.createElement('span');
        title.className = 'support-hub__option-title';
        title.textContent = m.title;
        var meta = document.createElement('span');
        meta.className = 'support-hub__option-meta';
        meta.textContent = [m.sku, m.series].filter(Boolean).join(' · ');
        text.appendChild(title);
        text.appendChild(meta);
        option.appendChild(text);
        list.appendChild(option);
      });

      noMatch.hidden = matches.length > 0;
      if (!matches.length) noMatchQ.textContent = '“' + query + '”';
      setOpen(matches.length > 0);
      if (query && matches.length) setActive(0);
    }

    function announce(message) {
      if (!status) return;
      status.textContent = '';
      setTimeout(function () { status.textContent = message; }, 50);
    }

    function videoCount(handle) {
      var cards = document.querySelectorAll('[data-sv-card]');
      var needle = ' ' + handle + ' ';
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        if ((' ' + (cards[i].getAttribute('data-products') || '') + ' ').indexOf(needle) !== -1) n += 1;
      }
      return n;
    }

    function broadcast(m) {
      document.dispatchEvent(new CustomEvent(EVENT, {
        detail: { handle: m ? m.handle : '', title: m ? m.title : '', sku: m ? m.sku : '', source: root }
      }));
    }

    function showMachine(m) {
      picker.hidden = true;
      panel.hidden = false;

      img.hidden = !m.image;
      if (m.image) img.src = m.image;
      seriesEl.textContent = m.series ? ' · ' + m.series : '';
      titleEl.textContent = m.title;
      skuRow.hidden = !m.sku;
      skuEl.textContent = m.sku;

      manualBtn.hidden = !m.manual;
      if (m.manual) manualBtn.href = m.manual;
      noManual.hidden = Boolean(m.manual);

      var n = videoCount(m.handle);
      videosBtn.hidden = n === 0;
      videosN.textContent = String(n);

      partsBtn.hidden = !(partsUrl && m.sku);
      if (partsUrl && m.sku) {
        partsBtn.href = partsUrl + (partsUrl.indexOf('?') === -1 ? '?' : '&') + 'pn=' + encodeURIComponent(m.sku);
      }
      productBtn.href = m.url;
    }

    // quiet: change the view only. Used for the page load and for changes that
    // another section started, so focus and the URL stay where they are.
    function choose(m, quiet) {
      if (!m) return;
      current = m;
      setOpen(false);
      input.value = '';
      noMatch.hidden = true;
      showMachine(m);
      if (!quiet) {
        writeMachineParam(m.handle);
        titleEl.focus();
        announce('Showing support for ' + m.title + '.');
      }
      broadcast(m);
    }

    function clearMachine(quiet) {
      current = null;
      panel.hidden = true;
      picker.hidden = false;
      if (!quiet) {
        writeMachineParam('');
        broadcast(null);
      }
    }

    input.addEventListener('input', renderOptions);
    input.addEventListener('focus', renderOptions);
    input.addEventListener('blur', function () { setOpen(false); });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (list.hidden) {
          renderOptions();
          if (active < 0) setActive(0);
        } else {
          setActive(Math.min(active + 1, matches.length - 1));
        }
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (!list.hidden) setActive(Math.max(active - 1, 0));
      } else if (event.key === 'Enter') {
        if (!list.hidden && active >= 0) {
          event.preventDefault();
          choose(matches[active]);
        } else if (matches.length === 1 && input.value.trim()) {
          event.preventDefault();
          choose(matches[0]);
        }
      } else if (event.key === 'Escape') {
        if (!list.hidden) {
          event.preventDefault();
          setOpen(false);
        } else if (input.value) {
          event.preventDefault();
          input.value = '';
          noMatch.hidden = true;
        }
      } else if (event.key === 'Tab') {
        setOpen(false);
      }
    });

    // Keep focus in the input while the pointer is on the list, so the list does not close first.
    list.addEventListener('mousedown', function (event) { event.preventDefault(); });
    list.addEventListener('click', function (event) {
      var option = event.target.closest('[role="option"]');
      if (option) choose(matches[Number(option.getAttribute('data-index'))]);
    });

    changeBtn.addEventListener('click', function () {
      clearMachine(false);
      input.focus();
    });

    videosBtn.addEventListener('click', function (event) {
      var library = document.querySelector('.support-videos');
      if (!library) return;
      event.preventDefault();
      // Focus first: in Chrome, focus() stops a smooth scroll that is in progress.
      var heading = library.querySelector('[data-sv-heading]');
      if (heading) heading.focus({ preventScroll: true });
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      library.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });

    document.addEventListener(EVENT, function (event) {
      var detail = event.detail || {};
      if (detail.source === root) return;
      if (!detail.handle) {
        if (current) clearMachine(true);
        return;
      }
      if (current && current.handle === detail.handle) return;
      var m = find(detail.handle);
      if (m) {
        current = m;
        showMachine(m);
      }
    });

    choose(find(readMachineParam()), true);
  }

  function scan() {
    document.querySelectorAll('[data-support-hub]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.hasAttribute('data-ss-ready')) return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ss-panel]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    root.setAttribute('data-ss-ready', '');

    var current = 0;

    function indexOfSlug(slug) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-ss-slug') === slug) return i;
      }
      return -1;
    }

    function writeHash(slug) {
      history.replaceState(history.state, '', location.pathname + location.search + '#' + slug);
    }

    // The page may already be below the step bar, for example after a long step.
    // Bring the bar back into view so the customer sees where they are.
    function reveal() {
      if (root.getBoundingClientRect().top >= 0) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    function show(index) {
      current = Math.max(0, Math.min(index, tabs.length - 1));
      tabs.forEach(function (tab, i) {
        var on = i === current;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        tab.parentNode.setAttribute('data-state', i < current ? 'past' : on ? 'current' : 'next');
        panels[i].hidden = !on;
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        show(i);
        writeHash(panels[i].getAttribute('data-ss-slug'));
      });
    });

    // Arrow keys move along the step bar, as in the ARIA tabs pattern.
    root.querySelector('[role="tablist"]').addEventListener('keydown', function (event) {
      var target = -1;
      if (event.key === 'ArrowRight') target = (current + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') target = (current - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = tabs.length - 1;
      if (target < 0) return;
      event.preventDefault();
      show(target);
      writeHash(panels[target].getAttribute('data-ss-slug'));
      tabs[target].focus();
    });

    root.addEventListener('click', function (event) {
      var go = event.target.closest('[data-ss-go]');
      if (!go) return;
      var target = Number(go.getAttribute('data-ss-go'));
      show(target);
      writeHash(panels[target].getAttribute('data-ss-slug'));
      var heading = panels[target].querySelector('[data-ss-heading]');
      if (heading) heading.focus({ preventScroll: true });
      reveal();
    });

    function openFromHash() {
      var index = indexOfSlug(decodeURIComponent(location.hash.slice(1)));
      if (index < 0) return;
      show(index);
      root.scrollIntoView({ block: 'start' });
    }

    window.addEventListener('hashchange', openFromHash);

    // In the theme editor, selecting a step block opens that step.
    document.addEventListener('shopify:block:select', function (event) {
      var index = panels.indexOf(event.target);
      if (index >= 0) show(index);
    });

    openFromHash();
  }

  function scan() {
    document.querySelectorAll('[data-support-steps]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  var EVENT = 'support:machine';
  var PARAM = 'machine';
  var ENT = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return ENT[c]; });
  }

  function escRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Product numbers get written many ways: "T1620-AS", "T1620 AS", "t1620as".
  // A second, punctuation-free index makes all three forms match each other.
  function compact(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function highlight(text, tokens) {
    var usable = tokens.filter(Boolean).map(escRe);
    if (!usable.length) return esc(text);
    var re = new RegExp('(' + usable.join('|') + ')', 'gi');
    return text.split(re).map(function (part, i) {
      return i % 2 ? '<mark class="support-videos__mark">' + esc(part) + '</mark>' : esc(part);
    }).join('');
  }

  function writeMachineParam(handle) {
    var params = new URLSearchParams(location.search);
    if (handle) params.set(PARAM, handle);
    else params.delete(PARAM);
    var search = params.toString();
    history.replaceState(history.state, '', location.pathname + (search ? '?' + search : '') + location.hash);
  }

  function init(root) {
    if (root.hasAttribute('data-sv-ready')) return;
    root.setAttribute('data-sv-ready', '');

    var input = root.querySelector('[data-sv-search]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sv-card]'));
    if (!input || !cards.length) return;

    var data = {};
    var dataEl = root.querySelector('[data-sv-data]');
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      data = {};
    }

    var clearBtn = root.querySelector('[data-sv-clear]');
    var list = root.querySelector('[data-sv-list]');
    var active = -1;
    var resetBtn = root.querySelector('[data-sv-reset]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-sv-chip]'));
    var seriesFilter = root.querySelector('[data-sv-series-filter]');
    var topics = Array.prototype.slice.call(root.querySelectorAll('[data-sv-topic]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sv-group]'));
    var startCollapsed = root.hasAttribute('data-sv-collapsed');

    // open: what shows now. userOpen: what the visitor chose with no filter on,
    // so clearing a search puts the groups back the way the visitor left them.
    var open = {};
    var userOpen = {};
    var lastFilter = '';
    groups.forEach(function (group) {
      var key = group.getAttribute('data-sv-group');
      open[key] = userOpen[key] = !startCollapsed;
    });

    function renderGroup(group) {
      var isOpen = Boolean(open[group.getAttribute('data-sv-group')]);
      var toggle = group.querySelector('[data-sv-group-toggle]');
      var grid = group.querySelector('[data-sv-group-grid]');
      group.classList.toggle('is-open', isOpen);
      if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (grid) grid.hidden = !isOpen;
    }
    var countEl = root.querySelector('[data-sv-count]');
    var machineEl = root.querySelector('[data-sv-machine]');
    var machineLabelEl = root.querySelector('[data-sv-machine-label]');
    var machineClear = root.querySelector('[data-sv-machine-clear]');
    var emptyEl = root.querySelector('[data-sv-empty]');
    var emptyText = root.querySelector('[data-sv-empty-text]');
    var dialog = root.querySelector('[data-sv-dialog]');
    var player = root.querySelector('[data-sv-player]');
    var dTitle = root.querySelector('[data-sv-dialog-title]');
    var dSeries = root.querySelector('[data-sv-dialog-series]');
    var dDesc = root.querySelector('[data-sv-dialog-desc]');
    var dFits = root.querySelector('[data-sv-dialog-fits]');
    var dProducts = root.querySelector('[data-sv-dialog-products]');
    var copyBtn = root.querySelector('[data-sv-copy]');
    var copyLabel = root.querySelector('[data-sv-copy-label]');
    var closeBtn = root.querySelector('[data-sv-close]');

    var series = 'all';
    var topic = 'all';
    var machine = '';
    var machineLabel = '';
    var openId = '';
    var copyTimer;

    // YouTube only renders maxresdefault for videos uploaded above 720p.
    root.querySelectorAll('[data-sv-thumb]').forEach(function (img) {
      img.addEventListener('error', function onErr() {
        img.removeEventListener('error', onErr);
        img.src = 'https://i.ytimg.com/vi/' + img.getAttribute('data-sv-thumb') + '/hqdefault.jpg';
      });
    });

    function labelFor(handle) {
      for (var key in data) {
        var hit = (data[key] || []).filter(function (p) { return p.handle === handle; })[0];
        if (hit) return hit.sku || hit.title;
      }
      return 'this machine';
    }

    function writeHash() {
      var parts = [];
      if (openId) parts.push('v=' + encodeURIComponent(openId));
      if (series !== 'all') parts.push('s=' + encodeURIComponent(series));
      if (topic !== 'all') parts.push('c=' + encodeURIComponent(topic));
      var hash = parts.length ? '#' + parts.join('&') : '';
      history.replaceState(history.state, '', location.pathname + location.search + hash);
    }

    function renderEmpty() {
      var strong = document.createElement('strong');
      emptyText.textContent = '';
      if (machine) {
        strong.textContent = machineLabel;
        emptyText.append('No videos for ', strong, ' yet.');
      } else {
        emptyText.append('No videos match this filter.');
      }
    }

    function apply() {
      var needle = ' ' + machine + ' ';
      var perSeries = {};
      var perTopic = {};
      var perGroup = {};
      var matched = 0;
      var matchedTopics = 0;
      var visible = 0;

      cards.forEach(function (card) {
        var keys = (card.getAttribute('data-series') || 'general').split(' ');
        var hitsText = true;
        var hitsMachine = !machine || (' ' + (card.getAttribute('data-products') || '') + ' ').indexOf(needle) !== -1;
        var cat = card.getAttribute('data-category') || 'general';
        var hitsSeries = Boolean(machine) || series === 'all' || keys.indexOf(series) !== -1;
        var hitsTopic = topic === 'all' || cat === topic;

        // Each filter row counts with every filter except its own, so a button
        // never promises results that its own filter would hide.
        if (hitsText && hitsMachine && hitsTopic) {
          matched += 1;
          keys.forEach(function (key) { perSeries[key] = (perSeries[key] || 0) + 1; });
        }
        if (hitsText && hitsMachine && hitsSeries) {
          matchedTopics += 1;
          perTopic[cat] = (perTopic[cat] || 0) + 1;
        }

        var shown = hitsText && hitsMachine && hitsSeries && hitsTopic;
        card.hidden = !shown;
        if (!shown) return;

        visible += 1;
        perGroup[cat] = (perGroup[cat] || 0) + 1;
      });

      chips.forEach(function (chip) {
        var key = chip.getAttribute('data-sv-chip');
        var n = key === 'all' ? matched : (perSeries[key] || 0);
        var nEl = chip.querySelector('.support-videos__chip-n');
        if (nEl) nEl.textContent = n;
        // Keep the active chip on screen so the visitor can always undo their own filter.
        chip.hidden = n === 0 && key !== 'all' && key !== series;
      });

      topics.forEach(function (button) {
        var key = button.getAttribute('data-sv-topic');
        var n = key === 'all' ? matchedTopics : (perTopic[key] || 0);
        var nEl = button.querySelector('.support-videos__topic-n');
        if (nEl) nEl.textContent = n;
        button.hidden = n === 0 && key !== 'all' && key !== topic;
      });

      // A new search or filter opens every group, so no match hides in a closed
      // group. With every filter off, the groups go back to the visitor's choice.
      var filter = [topic, series, machine].join('|');
      if (filter !== lastFilter) {
        var filtering = filter !== 'all|all|';
        groups.forEach(function (group) {
          var key = group.getAttribute('data-sv-group');
          open[key] = filtering || userOpen[key];
        });
        lastFilter = filter;
      }

      groups.forEach(function (group) {
        var n = perGroup[group.getAttribute('data-sv-group')] || 0;
        group.hidden = n === 0;
        var nEl = group.querySelector('[data-sv-group-n]');
        if (nEl) nEl.textContent = n;
        renderGroup(group);
      });

      if (countEl) countEl.textContent = visible + (visible === 1 ? ' video' : ' videos');
      if (machineEl) machineEl.hidden = !machine;
      // A machine already fixes the series, so the series chips only add noise.
      if (seriesFilter) seriesFilter.hidden = Boolean(machine);
      if (machineLabelEl) machineLabelEl.textContent = machineLabel;
      if (emptyEl) emptyEl.hidden = visible !== 0;
      if (emptyText && visible === 0) renderEmpty();
      writeHash();
    }

    function setSeries(next) {
      var exists = chips.some(function (chip) { return chip.getAttribute('data-sv-chip') === next; });
      series = exists ? next : 'all';
      chips.forEach(function (chip) {
        var on = chip.getAttribute('data-sv-chip') === series;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    }

    function setTopic(next) {
      var exists = topics.some(function (button) { return button.getAttribute('data-sv-topic') === next; });
      topic = exists ? next : 'all';
      topics.forEach(function (button) {
        var on = button.getAttribute('data-sv-topic') === topic;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    }

    // local: this section started the change, so it updates the URL and tells
    // the support hub. Changes that arrive from the hub only change the view.
    function setMachine(handle, label, local) {
      machine = handle || '';
      machineLabel = machine ? (label || labelFor(machine)) : '';
      if (local) {
        writeMachineParam(machine);
        document.dispatchEvent(new CustomEvent(EVENT, {
          detail: { handle: machine, title: '', sku: '', source: root }
        }));
      }
    }

    function openVideo(card) {
      if (!dialog || !player) return;
      var id = card.getAttribute('data-id');
      if (!id) return;

      openId = id;
      player.innerHTML =
        '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="' +
        esc(card.getAttribute('data-title') || 'Support video') +
        '" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

      if (dTitle) dTitle.textContent = card.getAttribute('data-title') || '';
      if (dSeries) {
        dSeries.textContent = [card.getAttribute('data-category-label'), card.getAttribute('data-series-label')]
          .filter(Boolean).join(' · ');
      }

      var desc = card.getAttribute('data-desc') || '';
      if (dDesc) {
        dDesc.textContent = desc;
        dDesc.hidden = !desc;
      }

      var products = data[card.getAttribute('data-key')] || [];
      if (dProducts) {
        dProducts.textContent = '';
        products.forEach(function (p) {
          var item = document.createElement('li');
          var link = document.createElement('a');
          link.className = 'support-videos__fit';
          link.href = p.url;
          if (p.image) {
            var img = document.createElement('img');
            img.className = 'support-videos__fit-img';
            img.src = p.image;
            img.alt = '';
            img.width = 40;
            img.height = 40;
            link.appendChild(img);
          }
          var text = document.createElement('span');
          text.className = 'support-videos__fit-text';
          var title = document.createElement('span');
          title.className = 'support-videos__fit-title';
          title.textContent = p.title;
          text.appendChild(title);
          if (p.sku) {
            var sku = document.createElement('span');
            sku.className = 'support-videos__fit-sku';
            sku.textContent = p.sku;
            text.appendChild(sku);
          }
          link.appendChild(text);
          item.appendChild(link);
          dProducts.appendChild(item);
        });
      }
      if (dFits) dFits.hidden = !products.length;

      resetCopy();
      document.documentElement.classList.add('support-videos-locked');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      if (closeBtn) closeBtn.focus();
      writeHash();
    }

    function resetCopy() {
      if (!copyBtn || !copyLabel) return;
      clearTimeout(copyTimer);
      copyBtn.classList.remove('is-done');
      copyLabel.textContent = 'Copy link to this video';
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (event) {
        // Leave modified clicks alone so the link still opens in a new tab.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        openVideo(card);
      });
    });

    // Tearing down only on the 'close' event is one point of failure too few:
    // if it never lands, the iframe keeps playing audio behind a closed dialog
    // and the page stays scroll-locked. This is idempotent, so every close path
    // calls it directly and the event is just one more trigger.
    function closeVideo() {
      if (player) player.innerHTML = '';
      openId = '';
      document.documentElement.classList.remove('support-videos-locked');
      if (dialog && dialog.open) dialog.close();
      writeHash();
    }

    if (dialog) {
      dialog.addEventListener('close', closeVideo);
      dialog.addEventListener('cancel', closeVideo);

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeVideo();
      });

      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeVideo();
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeVideo);

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        if (!openId) return;
        var url = location.origin + location.pathname + location.search + '#v=' + encodeURIComponent(openId);
        var done = function () {
          copyBtn.classList.add('is-done');
          copyLabel.textContent = 'Link copied';
          copyTimer = setTimeout(resetCopy, 2400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link', url); });
        } else {
          window.prompt('Copy this link', url);
        }
      });
    }

    // ---- Machine finder: the same pattern as the support hub's machine finder ----
    function setActive(index) {
      var previous = list.querySelector('[aria-selected="true"]');
      if (previous) previous.setAttribute('aria-selected', 'false');
      active = index;
      var option = index < 0 ? null : document.getElementById(list.id + '-' + index);
      if (!option) {
        active = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      option.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    function setListOpen(isOpen) {
      if (!list) return;
      list.hidden = !isOpen;
      input.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (!isOpen) setActive(-1);
    }

    function makeOption(i, className) {
      var li = document.createElement('li');
      li.id = list.id + '-' + i;
      li.className = className;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-index', String(i));
      return li;
    }

    // Every machine that has at least one video, from the products on the videos.
    var machines = [];
    (function () {
      var byHandle = {};
      Object.keys(data).forEach(function (key) {
        (data[key] || []).forEach(function (p) {
          if (!p || !p.handle) return;
          var m = byHandle[p.handle];
          if (!m) {
            m = byHandle[p.handle] = { handle: p.handle, title: p.title || '', sku: p.sku || '', image: p.image || '', count: 0 };
            m.index = (m.sku + ' ' + m.title).toLowerCase();
            m.compact = compact(m.index);
            machines.push(m);
          }
          m.count += 1;
        });
      });
      machines.sort(function (a, b) {
        return (a.sku || a.title).localeCompare(b.sku || b.title, undefined, { numeric: true });
      });
    })();
    var matches = [];

    function renderList() {
      if (!list) return;
      var query = input.value.toLowerCase().trim();
      var tokens = query ? query.split(/\s+/) : [];
      matches = machines.filter(function (m) {
        return tokens.every(function (token) {
          if (m.index.indexOf(token) !== -1) return true;
          var c = compact(token);
          return c !== '' && m.compact.indexOf(c) !== -1;
        });
      });
      list.textContent = '';

      matches.forEach(function (m, i) {
        var li = makeOption(i, 'support-videos__option');
        if (m.image) {
          var img = document.createElement('img');
          img.className = 'support-videos__fit-img';
          img.src = m.image;
          img.alt = '';
          img.width = 40;
          img.height = 40;
          img.loading = 'lazy';
          li.appendChild(img);
        }
        var text = document.createElement('span');
        text.className = 'support-videos__option-text';
        var title = document.createElement('span');
        title.className = 'support-videos__option-title';
        title.innerHTML = highlight(m.sku || m.title, tokens);
        var meta = document.createElement('span');
        meta.className = 'support-videos__option-meta';
        meta.innerHTML = highlight(m.sku ? m.title : '', tokens) +
          (m.sku ? ' · ' : '') + m.count + (m.count === 1 ? ' video' : ' videos');
        text.appendChild(title);
        text.appendChild(meta);
        li.appendChild(text);
        list.appendChild(li);
      });

      if (!matches.length && query) {
        var none = document.createElement('li');
        none.className = 'support-videos__option';
        none.setAttribute('role', 'presentation');
        var noneText = document.createElement('span');
        noneText.className = 'support-videos__option-meta';
        noneText.textContent = 'No machine matches this product number.';
        none.appendChild(noneText);
        list.appendChild(none);
      }

      setListOpen(matches.length > 0 || Boolean(query));
      if (matches.length && query) setActive(0);
    }

    function showResults() {
      setListOpen(false);
      var groupsEl = root.querySelector('[data-sv-grid]');
      if (!groupsEl) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      groupsEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    function choose(index) {
      var m = matches[index];
      if (!m) return;
      input.value = '';
      if (clearBtn) clearBtn.hidden = true;
      setMachine(m.handle, m.sku || m.title, true);
      setSeries('all');
      showResults();
    }

    input.addEventListener('input', function () {
      if (clearBtn) clearBtn.hidden = !input.value;
      renderList();
    });
    input.addEventListener('focus', renderList);
    input.addEventListener('blur', function () { setListOpen(false); });

    input.addEventListener('keydown', function (event) {
      var listOpen = list && !list.hidden;
      var last = list ? list.children.length - 1 : -1;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (!listOpen) renderList();
        else setActive(Math.min(active + 1, last));
      } else if (event.key === 'ArrowUp') {
        if (listOpen) {
          event.preventDefault();
          setActive(Math.max(active - 1, 0));
        }
      } else if (event.key === 'Enter') {
        if (listOpen && active >= 0) {
          event.preventDefault();
          choose(active);
        } else if (input.value.trim() && matches.length) {
          event.preventDefault();
          choose(0);
        }
      } else if (event.key === 'Escape') {
        if (listOpen) {
          event.preventDefault();
          event.stopPropagation();
          setListOpen(false);
        } else if (input.value) {
          event.stopPropagation();
          input.value = '';
          if (clearBtn) clearBtn.hidden = true;
        }
      } else if (event.key === 'Tab') {
        setListOpen(false);
      }
    });

    if (list) {
      // Keep focus in the input while the pointer is on the list, so the list does not close first.
      list.addEventListener('mousedown', function (event) { event.preventDefault(); });
      list.addEventListener('click', function (event) {
        var li = event.target.closest('[role="option"]');
        if (li) choose(Number(li.getAttribute('data-index')));
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        clearBtn.hidden = true;
        input.focus();
        renderList();
      });
    }

    if (machineClear) {
      machineClear.addEventListener('click', function () {
        setMachine('', '', true);
        setSeries('all');
        input.focus();
      });
    }

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        input.value = '';
        if (machine) setMachine('', '', true);
        setTopic('all');
        setSeries('all');
        input.focus();
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setSeries(chip.getAttribute('data-sv-chip'));
      });
    });

    topics.forEach(function (button) {
      button.addEventListener('click', function () {
        setTopic(button.getAttribute('data-sv-topic'));
      });
    });

    groups.forEach(function (group) {
      var key = group.getAttribute('data-sv-group');
      var toggle = group.querySelector('[data-sv-group-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        open[key] = !open[key];
        if (lastFilter === 'all|all|') userOpen[key] = open[key];
        renderGroup(group);
      });
    });

    document.addEventListener(EVENT, function (event) {
      var detail = event.detail || {};
      if (detail.source === root) return;
      if ((detail.handle || '') === machine) {
        if (machine && (detail.sku || detail.title)) {
          machineLabel = detail.sku || detail.title;
          apply();
        }
        return;
      }
      setMachine(detail.handle, detail.sku || detail.title, false);
      setSeries('all');
    });

    setMachine(new URLSearchParams(location.search).get(PARAM) || '', '', false);

    // Support agents can send a customer straight to one video, or to a filtered view.
    var hash = location.hash.replace(/^#/, '');
    var params = {};
    hash.split('&').forEach(function (pair) {
      var bits = pair.split('=');
      if (bits[0]) params[bits[0]] = decodeURIComponent((bits[1] || '').replace(/\+/g, ' '));
    });
    setTopic(params.c || 'all');
    setSeries(params.s || 'all');
    if (params.v) {
      var target = cards.filter(function (card) { return card.getAttribute('data-id') === params.v; })[0];
      if (target) {
        var targetGroup = target.closest('[data-sv-group]');
        if (targetGroup) {
          open[targetGroup.getAttribute('data-sv-group')] = true;
          renderGroup(targetGroup);
        }
        openVideo(target);
      }
    }
  }

  function scan() {
    document.querySelectorAll('[data-support-videos]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();
})();
